"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _nano = require("./nano");
var _variables = require("./variables");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var toasterStyles = _objectSpread({
  toaster: {
    position: 'fixed',
    bottom: '12px',
    right: '12px',
    zIndex: 9001,
    pointerEvents: 'none'
  },
  toast: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    pointerEvents: 'auto',
    overflow: 'hidden',
    margin: '0 0 6px',
    padding: '10px',
    paddingLeft: '40px',
    width: '300px',
    borderRadius: '3px',
    boxShadow: '0 0 12px #999',
    color: '#fff',
    opacity: 0,
    cursor: 'pointer',
    animation: 'cool-down 3s 1',
    '@keyframes cool-down': {
      '0%': {
        opacity: 0.8
      },
      '50%': {
        opacity: 0.8
      },
      '75%': {
        opacity: 0.4
      },
      '100%': {
        opacity: 0
      }
    },
    '&::before': {
      position: 'absolute',
      top: '50%',
      left: '10px',
      transform: 'translateY(-50%)',
      fontSize: '1.6rem'
    }
  },
  toast__title: {
    fontSize: '1.2rem',
    fontWeight: 'bold'
  }
}, (0, _toConsumableArray2["default"])(_variables.uiMessaging.entries()).reduce(function (p, _ref) {
  var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
    k = _ref2[0],
    data = _ref2[1];
  return _objectSpread(_objectSpread({}, p), {}, (0, _defineProperty2["default"])({}, "toast--".concat(k), {
    backgroundColor: data.background,
    color: data.colour,
    '&::before': {
      content: "\"".concat(data.icon, "\"")
    }
  }));
}, {}));
var _default = exports["default"] = (0, _nano.sheet)(toasterStyles);